import ApiBase from './Api'

const DOCS_API_PATHS = {
    DOCS: '/admin/docs',
}

class DocsApi extends ApiBase {
    async uploadUrl(filename: string) {
        const response = await this._postRequest(DOCS_API_PATHS.DOCS + '/presigned', { filename })

        return response as { uploadUrl: string; filename: string }
    }
}

export default DocsApi
